<div>
<!--    <div class="input-group pb-4">-->
<!--        <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="filter.customerSearchQuery">-->
<!--        <div class="input-group-append">-->
<!--                                    <span class="input-group-text" id="basic-addon1">-->
<!--                                        <i class="fas fa-search"></i>-->
<!--                                    </span>-->
<!--        </div>-->
<!--    </div>-->
<!--    <div class="pb-4 w-100">-->
<!--        <button class="btn btn-primary float-right" @click="onFilterSearchClicked">Search</button>-->
<!--    </div>-->
<!--    <br>-->
<!--    <br>-->
    <data-table
            :headings="customerHeadings"
            :data="customers"
            :hasActions="true"
            :hasCustomActionComponent="true"
            :pagingDetails="pagingDetails"
            @pagingUpdated="onPagingUpdated"
            @filterSearchClicked="onFilterSearchClicked">
        <template #filter>
            <div class="p-3">
                <div class="input-group pb-4">
                    <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="filter.customerSearchQuery">
                    <div class="input-group-append">
                        <span class="input-group-text" id="basic-addon1">
                            <i class="fas fa-search"></i>
                        </span>
                    </div>
                </div>
            </div>
        </template>
        <template #actionComponent="{ companyId, suspended }">
            <button class="btn btn-primary" @click="onCustomerSelect(companyId)" v-if="showSelectButton(suspended)">
                Select
            </button>
            <p class="text-danger" v-if="showSelectButton(suspended) === false">
                Suspended
            </p>
        </template>
    </data-table>
<!--    <div class="table-responsive pt-4">-->
<!--        <table class="table table-hover mb-0">-->
<!--            <thead>-->
<!--            <tr>-->
<!--                <th>Customer #</th>-->
<!--                <th>Customer Code</th>-->
<!--                <th>Name</th>-->
<!--                <th>-->
<!--                    Select-->
<!--                </th>-->
<!--            </tr>-->
<!--            </thead>-->
<!--            <tbody>-->
<!--            <tr v-for="(customer, index) in customers" :key="index">-->
<!--                <td>{{customer.companyId}}</td>-->
<!--                <td>{{customer.customerCode}}</td>-->
<!--                <td>{{customer.registeredCompanyName}}</td>-->
<!--                <td>-->
<!--                    <button class="btn btn-primary" @click="onCustomerSelect(customer)">Select</button>-->
<!--&lt;!&ndash;                    <input type="checkbox" v-model="customer.selected" @input="onCustomerSelect(customer)">&ndash;&gt;-->
<!--                </td>-->
<!--            </tr>-->
<!--            </tbody>-->
<!--        </table>-->
<!--    </div>-->
</div>